import "./Header.scss";
import NavLeft from "../NavLeft/NavLeft";
import NavLogo from "../NavLogo/NavLogo";
import NavRight from "../NavRight/NavRight";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="nav">
      <nav>
        {" "}
        <Link to="/" className="nav__link">
          <h1 className="nav__header">LowKeyBakerr</h1>
        </Link>
        <div className="nav__container">
          <NavLeft />
          <NavLogo />
          <NavRight />
        </div>
      </nav>
    </header>
  );
};

export default Header;
